<!--
 * @Author: Tahiti
 * @Date: 2025-12-10 18:15:30
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-29 16:52:01
 * @Description: 
 * @FilePath: /weryai-web/components/ui/UserProfile.vue
-->
<template>
    <div v-if="visible" class="fixed inset-0 z-[3000] flex items-end md:items-center justify-center bg-black/70">
        <div class="bg-[#1C1C20] absolute max-md:bottom-0 md:relative !rounded-[18px] custom custom-pop !p-4 md:p-[30px] w-full md:w-[80vw] h-[90vh] md:h-[800px] md:mx-4 flex flex-col overflow-hidden"
            @click.stop>
            <div
                class="w-full relative z-10 cursor-pointer flex items-center justify-between gap-3 md:gap-[40px] flex-shrink-0">
                <div v-if="chatList?.length"
                    class="flex items-center justify-start max-md:pb-5 gap-6 md:gap-[40px] overflow-x-auto whitespace-nowrap pr-2 scrollbar-hide">
                    <div v-for="item in tabEnums" :key="item.type"
                        class="text-center relative text-[16px] md:text-[20px] font-medium hover:text-white flex-shrink-0"
                        :class="[
                            activeTab === item.type
                                ? 'text-white is-active'
                                : 'text-white/40',
                        ]" @click="handleTabChange(item.type)">
                        <span>{{ item.name }}</span>
                    </div>
                </div>
                <div v-else
                    class="text-center relative text-[16px] md:text-[20px] font-medium hover:text-white flex-shrink-0">
                    {{ t('characterToImg.chooseCharacter') }}
                </div>
                <button @click="handleClose"
                    class="w-5 h-5 hidden md:flex max-md:pb-5 md:w-6 md:h-6  items-center justify-center text-white hover:rotate-180 transition-all duration-300 flex-shrink-0">
                    <img src="@/assets/images/common/_close.webp" alt="close" class="w-[20px] md:w-[24px]" />
                </button>
            </div>

            <!-- PC端筛选区域 - 常驻展示 -->
            <div v-if="activeTab === 'LATEST'"
                class="filterBox border p-3 md:p-5 border-white/10 bg-white/5 rounded-[12px] mt-2 md:mt-5 relative z-10 cursor-pointer md:flex flex-col gap-[16px] flex-shrink-0">
                <!-- 性别筛选 -->
                <div class="flex max-md:flex-col md:flex-row md:flex-wrap md:items-center gap-[12px]">
                    <!-- 标题 -->
                    <span class="text-white/40 text-[14px] leading-[1.171875em] font-medium"
                        style="font-family: Roboto, sans-serif">
                        {{ t('characterToImg.sexy') }}
                    </span>
                    <!-- 性别选项 -->
                    <div class="flex gap-[8px]">
                        <button v-for="genderOption in genderOptions" :key="genderOption.value"
                            class="flex items-center bg-[#323236] justify-center px-[20px] h-[40px] rounded-[6px] text-white text-[13px] leading-[1.171875em] font-normal transition-all duration-200 hover:opacity-80"
                            :class="selectedGenders.includes(genderOption.value)
                                ? 'border border-white/50'
                                : ''
                                " style="font-family: Roboto, sans-serif" @click="toggleGender(genderOption.value)">
                            {{ genderOption.label }}
                        </button>
                    </div>
                </div>

                <!-- 兴趣标签 -->
                <div class="flex max-md:mt-5 flex-col md:flex-row md:flex-wrap items-start gap-[8px]">
                    <span
                        class="md:min-h-[40px] flex items-center max-md:w-full justify-between md:justify-center text-white/40 text-[14px] leading-[1.171875em] font-medium"
                        style="font-family: Roboto, sans-serif">
                        <span>
                            {{ t('characterToImg.interest') }}
                        </span>

                        <!-- 右侧：展开/收起按钮 - 固定在右边 -->
                        <button v-show="needsExpandButton" class="h-full md:hidden flex items-center justify-center"
                            @click="toggleLabelsExpanded">
                            <span class="text-[#99F768] text-[13px] leading-[1.171875em] font-normal whitespace-nowrap"
                                style="font-family: Roboto, sans-serif">
                                {{
                                    isLabelsExpanded
                                        ? t('characters.collapse')
                                        : t('characters.expand')
                                }}
                            </span>
                            <svg class="w-[16px] h-[16px] transition-transform duration-200"
                                :class="{ 'rotate-180': isLabelsExpanded }" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M4 6L8 10L12 6" stroke="#99F768" stroke-width="1.6" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </button>
                    </span>
                    <!-- 左侧：标签容器 -->
                    <div id="interest" class="flex flex-wrap gap-2 flex-1 transition-all duration-300" :class="{
                        'max-h-[48px] overflow-hidden': !isLabelsExpanded,
                        'max-md:max-h-[120px] max-md:overflow-y-auto':
                            isLabelsExpanded,
                    }">
                        <!-- 标签按钮 -->
                        <button v-for="labelOption in labelOptions" :key="labelOption.value"
                            class="flex items-center bg-[#323236] justify-center px-[20px] h-[40px] rounded-[6px] text-white text-[13px] leading-[1.171875em] font-normal transition-all duration-200 hover:opacity-80 whitespace-nowrap"
                            :class="selectedLabels.includes(labelOption.value)
                                ? 'border border-white/50'
                                : ''
                                " style="font-family: Roboto, sans-serif" @click="toggleLabel(labelOption.value)">
                            {{ labelOption.label }}
                        </button>
                    </div>
                    <!-- 右侧：展开/收起按钮 - 固定在右边 -->
                    <div
                        class="hidden md:flex items-center justify-end md:justify-center h-[40px] transition-all duration-300">
                        <button v-show="needsExpandButton" class="h-full flex items-center justify-center"
                            @click="toggleLabelsExpanded">
                            <span class="text-[#99F768] text-[13px] leading-[1.171875em] font-normal whitespace-nowrap"
                                style="font-family: Roboto, sans-serif">
                                {{
                                    isLabelsExpanded
                                        ? t('characters.collapse')
                                        : t('characters.expand')
                                }}
                            </span>
                            <svg class="w-[16px] h-[16px] transition-transform duration-200"
                                :class="{ 'rotate-180': isLabelsExpanded }" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M4 6L8 10L12 6" stroke="#99F768" stroke-width="1.6" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <!-- 角色列表区域 -->
            <div ref="listContainer"
                class="flex-1 mt-3 md:mt-5 overflow-y-auto relative z-10 scrollbar-custom pb-28 md:pb-0">
                <!-- 列表内容区域（包含loading遮罩） -->
                <div class="relative min-h-[260px] md:min-h-[400px]">
                    <!-- Loading遮罩层 - 只遮盖列表区域 -->
                    <div v-if="isUpdatingData"
                        class="absolute inset-0 z-10 flex items-center justify-center rounded-lg">
                        <div class="text-center">
                            <div class="animate-spin rounded-full h-12 w-12 border-b-2 primary-border mx-auto mb-4">
                            </div>
                            <div class="text-white text-lg font-medium mb-2">
                                {{ t('characters.loading') }}
                            </div>
                            <div class="text-white/70 text-sm">
                                {{ t('characters.pleaseWait') }}
                            </div>
                        </div>
                    </div>

                    <!-- 暂无数据提示 -->
                    <div v-if="
                        !isUpdatingData &&
                        !loading &&
                        currentListData.length === 0
                    "
                        class="flex flex-col items-center justify-center py-[50px] md:py-[80px] min-h-[260px] md:min-h-[400px]">
                        <!-- 图标区域 -->
                        <div class="relative w-[120px] h-[120px] mb-[24px] flex items-center justify-center">
                            <!-- 背景光晕 -->
                            <div
                                class="absolute inset-0 bg-[#99F768] opacity-[0.06] blur-[40px] rounded-full pointer-events-none">
                            </div>
                            <!-- 圆形容器 -->
                            <div
                                class="relative w-[88px] h-[88px] bg-[#1A1C22] rounded-full flex items-center justify-center border border-white/[0.06] shadow-xl">
                                <svg class="w-[40px] h-[40px] text-white/20" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
                                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </div>
                        </div>

                        <h3 class="text-white text-[18px] font-medium mb-[12px]"
                            style="font-family: Roboto, sans-serif">
                            {{ t('characters.noCharactersFound') }}
                        </h3>

                        <p class="text-white/40 text-[14px] leading-[1.6em] text-center max-w-[260px] mb-[32px]"
                            style="font-family: Roboto, sans-serif">
                            {{ t('characters.adjustFilters') }}<br />{{
                                t('characters.adjustFiltersSuggestion')
                            }}
                        </p>

                        <!-- 重置按钮 -->
                        <button
                            class="h-[40px] px-[24px] rounded-full bg-white/[0.06] hover:bg-white/[0.12] border border-white/[0.08] hover:border-white/[0.2] text-white/90 text-[14px] font-medium transition-all duration-300 flex items-center gap-[8px] group"
                            @click="handleReset">
                            <svg class="w-4 h-4 text-white/60 group-hover:text-[#99F768] transition-colors duration-300"
                                viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4"
                                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                            </svg>
                            {{ t('characters.resetAll') }}
                        </button>
                    </div>

                    <!-- 列表内容 - SSR + 个性化加载 -->
                    <div v-if="!isUpdatingData && currentListData.length > 0"
                        class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-x-[10px] gap-y-[15px] md:gap-x-[20px] md:gap-y-[40px] transition-opacity duration-300">
                        <div v-for="character in currentListData" :key="character.id || character.match_mate_id"
                            class="flex flex-col gap-[10px] cursor-pointer transition-all duration-300 w-full group">
                            <!-- 图片区域 -->
                            <div class="relative w-full character-card-image">
                                <ImageLazy :src="character?.avatar" :alt="character?.name"
                                    :is-video="character?.is_video" :autoplay="false" :allow-load="!isUpdatingData"
                                    root-margin="100px" container-class="w-full h-full" image-class="rounded-[10px]"
                                    placeholder-class="rounded-[10px] bg-gray-800" :character-id="character.id?.toString() ||
                                        character.match_mate_id?.toString()
                                        " exposure-page="character_list_page" @error="handleImageError" @click.stop="
                                            emitter.emit(
                                                'open-image-preview',
                                                character?.is_video
                                                    ? character.avatarIcon
                                                    : character.avatar
                                            )
                                            " />
                                <h3 class="text-white truncate w-full text-center p-2 md:p-3 name-item absolute bottom-0 h-[36px] md:h-[43px] text-[14px] md:text-base leading-[1.171875em] font-normal"
                                    :title="character.name">
                                    {{ character.name }}
                                </h3>
                                <span
                                    class="normal-select absolute top-1 right-1 w-[22px] h-[22px] flex items-center justify-center"
                                    @click="handleSelectItem(character)">
                                    <span v-show="isSelected(character)"
                                        class="select-active-icon w-[14px] h-[14px]"></span>
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- 加载状态提示 -->
                    <div v-if="!isUpdatingData && loading" class="text-center py-8 mt-4">
                        <DotSpinner />
                    </div>
                    <!-- 错误状态提示 -->
                    <div v-else-if="!isUpdatingData && error" class="text-center py-4 mt-4">
                        <p class="text-white/60 text-sm">
                            {{ t('characters.loadFailed') }}
                        </p>
                    </div>
                    <!-- 没有更多数据提示 -->
                    <div v-else-if="
                        !isUpdatingData &&
                        finished &&
                        currentListData.length > 0
                    " class="text-center py-4 mt-4 text-white/40 text-sm">
                        {{ t('characters.noMoreData') }}
                    </div>

                    <!-- 加载更多触发器（IntersectionObserver 监听） -->
                    <div ref="loadMoreSentinel" class="h-4 w-full" aria-hidden="true"></div>
                </div>
                <!-- 列表内容区域结束 -->
            </div>
            <!-- 展示已选择的 -->
            <ClientOnly>
                <div v-if="select_list?.length"
                    class="sticky max-md:min-h-[120px] md:relative bottom-0 z-10 flex flex-col md:flex-row md:items-center justify-between gap-3 mt-3 md:mt-[18px] px-0 py-3 md:py-0 bg-[#1C1C20]/95 md:bg-transparent backdrop-blur safe-bottom">
                    <div class="flex-1 min-w-0 flex items-center justify-start mx-0">
                        <div class="text-sm hidden mr-3 md:block text-white/40 font-medium flex-shrink-0">
                            ({{ select_list.length }}/{{ max_limit }})
                        </div>
                        <div
                            class="flex-1 min-w-0 overflow-x-auto flex items-center justify-start gap-2 scrollbar-hide">
                            <div v-for="(item, idx_) in select_list" :key="idx_"
                                class="min-w-[50px] flex-shrink-0 h-[36px] md:h-[40px] px-3 py-1 rounded-[35px] bg-white/5 hover:bg-white/[0.12] text-white text-[13px] md:text-[14px] transition-all duration-300 flex items-center justify-between gap-[10px] md:gap-[14px]">
                                <span class="flex items-center gap-1">
                                    <img :src="item?.is_video
                                        ? item.avatarIcon
                                        : item.avatar
                                        " alt="avatar"
                                        class="w-[24px] h-[24px] md:w-[28px] md:h-[28px] rounded-full" />
                                    <span class="whitespace-nowrap max-w-[100px] truncate">
                                        {{ item?.name }}
                                    </span>
                                </span>
                                <svg class="cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                    viewBox="0 0 20 20" fill="none" @click="handleRemoveItem(item)">
                                    <rect width="20" height="20" rx="10" fill="white" fill-opacity="0.1" />
                                    <path
                                        d="M13.2961 12.5488C13.5011 12.754 13.5009 13.0867 13.2961 13.292C13.0908 13.4973 12.7573 13.4973 12.5519 13.292L9.95135 10.6904L7.34784 13.2939C7.14265 13.4991 6.81 13.4989 6.60467 13.2939C6.39936 13.0887 6.39936 12.7551 6.60468 12.5498L9.20721 9.94727L6.6037 7.34473C6.39886 7.13945 6.39867 6.80672 6.6037 6.60156C6.80901 6.39627 7.14253 6.39627 7.34784 6.60156L9.95135 9.20312L12.5519 6.60254C12.7573 6.39735 13.0908 6.39728 13.2961 6.60254C13.5014 6.80781 13.5013 7.14139 13.2961 7.34668L10.6955 9.94727L13.2961 12.5488Z"
                                        fill="white" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <div
                        class="flex-shrink-0 max-md:w-full flex items-center md:justify-end justify-center gap-[12px] md:gap-[14px] border-l-0 md:border-l border-white/10 pl-0 md:pl-5 w-full md:w-auto">
                        <button
                            class="max-md:min-w-[120px] px-3 md:flex-1 max-md:h-[41px] max-md:rounded-[14px] md:min-w-[66px] md:flex-shrink-0 h-[36px] rounded-[6px] bg-white/5 hover:bg-white/[0.12] text-white font-bold text-[14px] transition-all duration-300 flex items-center justify-center"
                            @click="handleClose">
                            {{ t('characterToImg.cancel') }}
                        </button>
                        <button
                            class="max-md:min-w-[120px] px-3 md:flex-1 max-md:h-[41px] max-md:rounded-[14px] md:min-w-[66px] md:flex-shrink-0 h-[36px] rounded-[6px] bg-[#99F768] hover:bg-[#99F768]/80 text-black font-medium text-[14px] transition-all duration-300 flex items-center justify-center"
                            @click="handleSubmitSelectList">
                            {{ t('characterToImg.confirm') }}
                            <span class="block md:hidden">
                                ({{ select_list.length }}/{{ max_limit }})
                            </span>
                        </button>
                    </div>
                </div>
            </ClientOnly>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted, onUnmounted, nextTick } from 'vue'
import { useI18n } from '~/composables/useI18n'
import { updateUserInfoApi } from '~/api/user'
import { noticeMessagePopup, debounce, getMaxImageSize } from '~/utils/common'
import { useUserStore } from '~/stores/user'
import { showLoginModal } from '~/utils/emitter'
import { getCharacterList, matchRole } from '~/api/mate/characters'
import type { CharacterItem } from '~/api/mate/characters'
import { getMessageList } from '~/api/mate/message'
import type { MessageItem } from '~/api/mate/message'
import { useAppStore } from '~/stores/app'
import {
    useLocalePath,
    definePageMeta,
    useHead,
    useRequestURL,
    useRoute,
} from '#imports'
// useMultilingualSeo 不再使用，页面直接控制所有 SEO 标签
import ImageLazy from '~/components/mate/ImageLazy.vue'
import DotSpinner from '~/components/DotSpinner.vue'
import VipModal from '~/components/VIP/VipModal.vue'
import { ElMessage } from 'element-plus'
import { methodLock } from '~/utils/mate/mateCommon'
import { analyticsEvent } from '~/utils/log-event-func'
import FilterDrawer from '~/pages/characters/components/FilterDrawer.vue'

const props = defineProps<{
    max_limit: number
    edit_image_list: Array<any>
    character_select_list: Array<any>
}>()
const userStore = useUserStore()
const { t, locale } = useI18n()
const visible = defineModel<boolean>('visible', { required: true })

const is_client = import.meta.client

const tabEnums = computed(() => [
    {
        name: t('characterToImg.chat_character'),
        type: 'HISTORY',
    },
    {
        name: t('characterToImg.all_character'),
        type: 'LATEST',
    },
])

const activeTab = ref('LATEST')

// mate 角色 start
const characterList = ref<CharacterItem[]>([])

// 筛选相关状态
const showFilterDrawer = ref(false) // 移动端筛选抽屉
const isLabelsExpanded = ref(false) // PC端标签展开状态
const needsExpandButton = ref(false) // 是否需要显示展开按钮

// 性别筛选选项
const genderOptions = computed(() => [
    { label: t('characters.male'), value: 'MALE' },
    { label: t('characters.female'), value: 'FEMALE' },
])
const selectedGenders = ref<string[]>(['MALE', 'FEMALE']) // 默认选中两个

// 兴趣标签选项
const labelOptions = computed(() => [
    { label: t('characters.tagAll'), value: 'ALL' },
    // { label: t('characters.tagNsfw'), value: 'NSFW' },
    // 关系标签
    { label: t('characters.tagTwoDimensional'), value: 'TWO_DIMENSIONAL' },
    { label: t('characters.tagRoommate'), value: 'ROOMMATE' },
    { label: t('characters.tagNeighbor'), value: 'NEIGHBOR' },
    { label: t('characters.tagMarried'), value: 'MARRIED' },
    { label: t('characters.tagEx'), value: 'EX' },
    {
        label: t('characters.tagChildhoodSweetheart'),
        value: 'CHILDHOOD_SWEETHEART',
    },
    { label: t('characters.tagBoss'), value: 'BOSS' },
    { label: t('characters.tagSubordinate'), value: 'SUBORDINATE' },
    { label: t('characters.tagTeacherStudent'), value: 'TEACHER_STUDENT' },
    { label: t('characters.tagArchEnemy'), value: 'ARCH_ENEMY' },
    { label: t('characters.tagStranger'), value: 'STRANGER' },
    { label: t('characters.tagContractPartner'), value: 'CONTRACT_PARTNER' },
    // 身份标签
    { label: t('characters.tagRichFamily'), value: 'RICH_FAMILY' },
    { label: t('characters.tagMafia'), value: 'MAFIA' },
    { label: t('characters.tagDoctor'), value: 'DOCTOR' },
    { label: t('characters.tagIdol'), value: 'IDOL' },
    { label: t('characters.tagAssassin'), value: 'ASSASSIN' },
    { label: t('characters.tagMaid'), value: 'MAID' },
    { label: t('characters.tagLandlord'), value: 'LANDLORD' },
    // 性格标签
    { label: t('characters.tagYandere'), value: 'YANDERE' },
    { label: t('characters.tagTsundere'), value: 'TSUNDERE' },
    { label: t('characters.tagAloof'), value: 'ALOOF' },
    { label: t('characters.tagShy'), value: 'SHY' },
    { label: t('characters.tagDominant'), value: 'DOMINANT' },
    { label: t('characters.tagSubmissive'), value: 'SUBMISSIVE' },
    { label: t('characters.tagGentle'), value: 'GENTLE' },
    { label: t('characters.tagAirhead'), value: 'AIRHEAD' },
    { label: t('characters.tagStrict'), value: 'STRICT' },
    { label: t('characters.tagObsessed'), value: 'OBSESSED' },
    { label: t('characters.tagScheming'), value: 'SCHEMING' },
    // 风格标签
    { label: t('characters.tagPureLove'), value: 'PURE_LOVE' },
    { label: t('characters.tagMilf'), value: 'MILF' },
    { label: t('characters.tagDilf'), value: 'DILF' },
    { label: t('characters.tagCurvy'), value: 'CURVY' },
    { label: t('characters.tagMuscular'), value: 'MUSCULAR' },
    { label: t('characters.tagPetite'), value: 'PETITE' },
    { label: t('characters.tagGothic'), value: 'GOTHIC' },
    { label: t('characters.tagHotGirl'), value: 'HOT_GIRL' },
    { label: t('characters.tagUniform'), value: 'UNIFORM' },
    // 种族标签
    { label: t('characters.tagVampire'), value: 'VAMPIRE' },
    { label: t('characters.tagWerewolf'), value: 'WEREWOLF' },
    { label: t('characters.tagDemon'), value: 'DEMON' },
    { label: t('characters.tagSuccubus'), value: 'SUCCUBUS' },
    { label: t('characters.tagOrc'), value: 'ORC' },
    { label: t('characters.tagMonsterGirl'), value: 'MONSTER_GIRL' },
    { label: t('characters.tagRobot'), value: 'ROBOT' },
    { label: t('characters.tagElf'), value: 'ELF' },
    // 类型标签
    { label: t('characters.tagDoujin'), value: 'DOUJIN' },
    { label: t('characters.tagAnime'), value: 'ANIME' },
    { label: t('characters.tagStepRelative'), value: 'STEP_RELATIVE' },
    { label: t('characters.tagWorkplace'), value: 'WORKPLACE' },
    { label: t('characters.tagSchool'), value: 'SCHOOL' },
    { label: t('characters.tagFantasy'), value: 'FANTASY' },
    { label: t('characters.tagUrban'), value: 'URBAN' },
    { label: t('characters.tagBlindDate'), value: 'BLIND_DATE' },
    { label: t('characters.tagDark'), value: 'DARK' },
    // 性向标签
    { label: t('characters.tagBoysLove'), value: 'BOYS_LOVE' },
    { label: t('characters.tagGirlsLove'), value: 'GIRLS_LOVE' },
    { label: t('characters.tagLgbt'), value: 'LGBT' },
])
const selectedLabels = ref<string[]>(['ALL']) // 默认选中ALL

// 防抖定时器 - 用于筛选条件变化
let filterDebounceTimer: ReturnType<typeof setTimeout> | null = null

// 分页相关状态
const loading = ref(false)
const error = ref(false)
const finished = ref(false)
// LATEST（所有角色）专用：记住“是否还有更多”，避免切 tab 时被覆盖或被强制重置
const finishedLatest = ref(false)
const offset = ref('0')
const pageCursor = ref('')
const pageSize = 30

// 数据状态管理
const isPersonalizedData = ref(false) // 标识当前是否为个性化数据
const isUpdatingData = ref(true) // 初始就显示loading，根据用户状态决定何时移除

// 聊天列表相关状态
const chatList = ref<MessageItem[]>([])
const chatListLoading = ref(false)

// 窗口高度
const windowHeight = ref(0)

// 动态计算可显示的聊天头像数量
const maxDisplayChats = computed(() => {
    if (!import.meta.client || windowHeight.value === 0) {
        return 5 // 默认显示5个
    }

    // 右侧栏总高度：vh - 100px
    const sidebarHeight = windowHeight.value - 100

    // 固定元素高度：
    // - 上下 padding: 40px
    // - 标题区域: 20px
    // - 标题到列表的 gap: 20px
    // - 分隔线区域 (mt-20px + 1px): 21px
    // - 三点菜单区域 (mt-20px + 20px): 40px
    const fixedHeight = 40 + 20 + 20 + 21 + 40 // 141px

    // 可用于显示头像的高度
    const availableHeight = sidebarHeight - fixedHeight

    // 每个头像单元高度：42px + 10px gap = 52px
    const itemHeight = 52

    // 计算可显示的数量（向下取整，确保不显示半个）
    const maxCount = Math.floor(availableHeight / itemHeight)

    // 至少显示1个，最多显示实际聊天数量
    return Math.max(1, Math.min(maxCount, chatList.value.length))
})

// 显示的聊天数量（动态截取）
const displayedChats = computed(() =>
    chatList.value.slice(0, maxDisplayChats.value)
)

// 聊天列表弹窗状态
const showChatListDialog = ref(false)
const showMobileChatList = ref(false)

// 角色详情弹窗状态
const showCharacterDetail = ref(false)
const selectedCharacterId = ref('')

// 无限滚动加载
const listContainer = ref<HTMLElement | null>(null)
const loadMoreSentinel = ref<HTMLElement | null>(null)
let loadMoreObserver: IntersectionObserver | null = null

// 初始化滚动监听器
const initObserver = () => {
    if (!import.meta.client) return

    // 如果已经存在监听器，先销毁
    if (loadMoreObserver) {
        loadMoreObserver.disconnect()
        loadMoreObserver = null
    }

    nextTick(() => {
        const container = listContainer.value
        const sentinel = loadMoreSentinel.value

        if (sentinel && container) {
            console.log('初始化滚动监听器...')
            const observer = new IntersectionObserver(
                entries => {
                    if (
                        entries[0]?.isIntersecting &&
                        activeTab.value === 'LATEST' &&
                        !loading.value &&
                        !finished.value &&
                        !isUpdatingData.value
                    ) {
                        console.log('触发无限滚动加载...')
                        onLoad()
                    }
                },
                {
                    root: container,
                    rootMargin: '200px',
                }
            )
            observer.observe(sentinel)
            loadMoreObserver = observer
        } else {
            console.warn('初始化滚动监听失败：找不到容器或哨兵元素', {
                container: !!container,
                sentinel: !!sentinel,
            })
        }
    })
}

// SSR 数据获取 - 使用 useAsyncData 包装 API 调用以支持 SSR
// eslint-disable-next-line no-undef
const { data: initialData, pending: initialDataPending } = await useAsyncData(
    `characters-characters-${locale.value}`,
    () => getCharacterList('0', pageSize, '', 'LATEST', 'ALL', undefined),
    {
        lazy: true, // 不阻塞导航
    }
)

// 如果SSR数据在初始化时就已经ready，立即设置
if (initialData.value && characterList.value.length === 0) {
    console.log('初始化：SSR数据已就绪，立即设置')
    characterList.value = initialData.value.list
    offset.value = initialData.value.offset
    pageCursor.value = initialData.value.page_cursor
    finished.value = !initialData.value.hasMore
    finishedLatest.value = finished.value
}

// Tab 切换处理
const handleTabChange = (tabValue: string) => {
    if (activeTab.value === tabValue) return
    activeTab.value = tabValue
    if (tabValue === 'HISTORY') {
        error.value = false
        // HISTORY 列表不支持无限滚动；不要污染 LATEST 的 finished 状态
        return
    }
    // 切回 LATEST：恢复“真实的”分页状态（不要强行 finished=false）
    error.value = false
    finished.value = finishedLatest.value
    nextTick(() => {
        initObserver()
    })
}

// 筛选按钮点击处理（仅移动端使用）
const handleFilterClick = () => {
    // 移动端：显示抽屉
    showFilterDrawer.value = true
}

// 切换标签展开/收起状态
const toggleLabelsExpanded = () => {
    isLabelsExpanded.value = !isLabelsExpanded.value
    // 收起的时候 如果是移动端，先把标签内容滚动到顶部
    if (!isLabelsExpanded.value && import.meta.client) {
        const labelContainer = document.getElementById('interest')
        if (labelContainer) {
            labelContainer.scrollTop = 0
        }
    }
}

// 检测是否需要展开按钮（标签是否超过一行）
const checkNeedsExpandButton = () => {
    if (!import.meta.client) return

    // 使用延迟确保 DOM 已完全渲染，特别是在弹窗开启或屏幕尺寸变化时
    setTimeout(() => {
        nextTick(() => {
            // 直接通过 ID 获取标签容器，这样比层级选择更可靠
            const labelContainer = document.getElementById('interest')
            if (!labelContainer) return

            // 临时记录是否包含折叠样式
            const hadMaxHeightClass =
                labelContainer.classList.contains('max-h-[48px]')

            // 移除限制以进行准确的高度/位置测量
            labelContainer.classList.remove('max-h-[48px]', 'overflow-hidden')

            // 获取所有子标签按钮
            const buttons = Array.from(labelContainer.children) as HTMLElement[]
            if (buttons.length === 0) {
                // 恢复样式
                if (hadMaxHeightClass && !isLabelsExpanded.value) {
                    labelContainer.classList.add(
                        'max-h-[48px]',
                        'overflow-hidden'
                    )
                }
                needsExpandButton.value = false
                return
            }

            // 获取第一个标签按钮的 top 位置
            const firstButtonTop = buttons[0]?.offsetTop || 0

            // 检查是否有标签按钮在第二行或更多行
            const hasMultipleRows = buttons.some(
                btn => btn.offsetTop > firstButtonTop
            )

            // 恢复折叠样式
            if (hadMaxHeightClass && !isLabelsExpanded.value) {
                labelContainer.classList.add('max-h-[48px]', 'overflow-hidden')
            }

            needsExpandButton.value = hasMultipleRows
        })
    }, 200) // 略微增加延迟以确保布局稳定
}

// 性别筛选切换
const toggleGender = (gender: string) => {
    const index = selectedGenders.value.indexOf(gender)
    if (index > -1) {
        // 已选中，尝试取消
        if (selectedGenders.value.length > 1) {
            selectedGenders.value.splice(index, 1)
        }
        // 如果只剩一个，不允许取消
    } else {
        // 未选中，添加
        selectedGenders.value.push(gender)
    }
    // 使用防抖应用筛选
    debouncedApplyFilters()
}

// 兴趣标签切换
const toggleLabel = (label: string) => {
    if (label === 'ALL') {
        // 点击ALL，只选中ALL
        selectedLabels.value = ['ALL']
    } else {
        // 点击非ALL标签
        const allIndex = selectedLabels.value.indexOf('ALL')
        if (allIndex > -1) {
            // 如果ALL被选中，取消ALL，选中当前标签
            selectedLabels.value = [label]
        } else {
            const index = selectedLabels.value.indexOf(label)
            if (index > -1) {
                // 已选中，尝试取消
                if (selectedLabels.value.length > 1) {
                    selectedLabels.value.splice(index, 1)
                }
                // 如果只剩一个，不允许取消
            } else {
                // 未选中，添加
                selectedLabels.value.push(label)

                // 检查是否所有非ALL标签都被选中
                const allNonAllLabels = labelOptions.value
                    .filter(
                        (opt: { label: string; value: string }) =>
                            opt.value !== 'ALL'
                    )
                    .map((opt: { label: string; value: string }) => opt.value)
                const allSelected = allNonAllLabels.every((val: string) =>
                    selectedLabels.value.includes(val)
                )

                if (allSelected) {
                    // 所有标签都选中了，自动选中ALL，取消其他
                    selectedLabels.value = ['ALL']
                }
            }
        }
    }
    // 使用防抖应用筛选
    debouncedApplyFilters()
}

// 更新选中的性别（从抽屉组件）
const updateSelectedGenders = (genders: string[]) => {
    selectedGenders.value = genders
}

// 更新选中的标签（从抽屉组件）
const updateSelectedLabels = (labels: string[]) => {
    selectedLabels.value = labels
}

// 应用筛选（立即执行，无防抖）
const applyFilters = () => {
    console.log('应用筛选:', {
        genders: selectedGenders.value,
        labels: selectedLabels.value,
    })
    // 重新加载数据
    resetList()
}

// 防抖版本的应用筛选 - 1秒内无操作后才执行
const debouncedApplyFilters = () => {
    // 清除之前的定时器
    if (filterDebounceTimer) {
        clearTimeout(filterDebounceTimer)
    }

    // 设置新的定时器
    filterDebounceTimer = setTimeout(() => {
        applyFilters()
        filterDebounceTimer = null
    }, 1000) // 1秒防抖
}

// 跳转到角色详情页面
const handleChatClick = (character: CharacterItem) => {
    // 检查并锁定，防止重复点击
    if (!methodLock.checkAndLock('chat-click')) return

    try {
        console.log('跳转到角色详情页面:', character.name)

        const localePath = useLocalePath()
        const profilePath = localePath(`/characterProfile/${character.id}`)
        navigateTo(profilePath)
    } finally {
        // 跳转完成后解锁
        setTimeout(() => methodLock.unlock('chat-click'), 500) // 延迟解锁避免快速重复跳转
    }
}

// 喜欢操作
const handleLike = async (character: CharacterItem) => {
    // 检查并锁定，防止重复点击（接口响应前不能再次点击）
    if (!methodLock.checkAndLock('like-action')) return

    try {
        // 埋点：点击角色卡片
        analyticsEvent('click_character_card', {
            character_id: character.id.toString(),
            click_page: 'character_list_page',
        })

        // 判断用户是否登录
        if (!userStore.isLoggedIn) {
            // 未登录：打开角色详情弹窗
            selectedCharacterId.value = character.id.toString()
            showCharacterDetail.value = true
            return
        }

        // 已登录：调用匹配接口并跳转到聊天页面
        const response = await matchRole({
            match_mate_id: character.id,
            match_type: 'LIKE',
        })

        if (response && response.status === 200) {
            console.log('喜欢操作成功')
            // 跳转到聊天页面，使用本地化路径和查询参数传递chatId
            const localePath = useLocalePath()
            const messagePath = localePath(`/chat/${response.data.my_mate_id}`)
            navigateTo(messagePath)
        } else {
            console.error('喜欢操作失败:', response)
            if (import.meta.client && response?.status !== 1005) {
                ElMessage.error(
                    response?.desc ||
                    response?.message ||
                    t('characters.toast.operationFailed')
                )
            }
        }
    } catch (error) {
        console.error('喜欢操作异常:', error)
    } finally {
        // 无论成功失败都要解锁
        methodLock.unlock('like-action')
    }
}

// 图片/视频加载错误处理
const handleImageError = (src: string) => {
    console.error('图片/视频加载失败:', src)
    // LazyImage组件内部会显示错误状态，这里只需要记录日志
}

// 加载聊天列表
const loadChatList = async () => {
    try {
        chatListLoading.value = true

        const response = await getMessageList()

        if (response && response.status === 200 && response.data) {
            chatList.value = response.data.messages || []
            chatList.value = chatList.value.map(item => {
                return {
                    ...item,
                    id: item.match_mate_id,
                }
            })
        }
    } catch (error) {
        console.error('加载聊天列表失败:', error)
    } finally {
        chatListLoading.value = false
    }
}

// 点击聊天项
const handleChatItemClick = (chat: MessageItem) => {
    // 检查并锁定，防止重复点击
    if (!methodLock.checkAndLock('chat-item-click')) return

    try {
        console.log('跳转到聊天页面:', chat.name)

        const localePath = useLocalePath()
        const messagePath = localePath(`/chat/${chat.mate_id}`)
        navigateTo(messagePath)
    } finally {
        // 跳转完成后解锁
        setTimeout(() => methodLock.unlock('chat-item-click'), 500)
    }
}

// 显示更多聊天（移动端打开全屏页面，PC端打开弹窗）
const showMoreChats = () => {
    if (import.meta.client) {
        const isMobile = window.innerWidth < 1024 // lg断点
        if (isMobile) {
            // 移动端：显示全屏聊天列表
            showMobileChatList.value = true
        } else {
            // PC端：显示弹窗
            showChatListDialog.value = true
        }
    } else {
        // 服务端渲染时默认使用弹窗
        showChatListDialog.value = true
    }
}

// 处理角色详情弹窗的聊天事件
const handleCharacterDetailChat = async (characterId: string) => {
    // 检查并锁定，防止重复点击
    if (!methodLock.checkAndLock('detail-chat-action')) return

    try {
        console.log('从详情弹窗开始聊天:', characterId)

        // 调用匹配接口
        const response = await matchRole({
            match_mate_id: Number(characterId),
            match_type: 'LIKE',
        })

        if (response && response.status === 200) {
            console.log('匹配成功')
            // 跳转到聊天页面
            const localePath = useLocalePath()
            const messagePath = localePath(`/chat/${response.data.my_mate_id}`)
            navigateTo(messagePath)
        } else {
            console.error('匹配失败:', response)
            if (import.meta.client && response?.status !== 1005) {
                ElMessage.error(
                    response?.desc ||
                    response?.message ||
                    t('characters.toast.operationFailed')
                )
            }
        }
    } catch (error) {
        console.error('匹配异常:', error)
    } finally {
        methodLock.unlock('detail-chat-action')
    }
}

// 加载角色列表数据（客户端动态调用，直接使用 API）
const loadCharacterList = async (isLoadMore = false) => {
    try {
        loading.value = true
        error.value = false

        // 准备筛选参数
        const gender =
            selectedGenders.value.length === 2
                ? 'ALL'
                : selectedGenders.value[0]

        // labels：只有选中非ALL标签时才传递，用逗号拼接成字符串
        const labels = selectedLabels.value.includes('ALL')
            ? undefined
            : selectedLabels.value.join(',') // 用逗号拼接数组

        // 直接调用 API（内部使用 $fetch，可以在任何地方调用）
        const response = await getCharacterList(
            offset.value,
            pageSize,
            pageCursor.value,
            activeTab.value, // 推荐类型
            gender, // 性别筛选
            labels // 兴趣标签字符串（选中ALL时为undefined，不传递）
        )

        if (response) {
            // 如果不是加载更多，且loading正在显示，先关闭loading再更新数据
            if (!isLoadMore && isUpdatingData.value) {
                isUpdatingData.value = false
                // 等待一帧确保loading UI更新
                await nextTick()
            }

            if (isLoadMore) {
                // 加载更多：追加数据
                characterList.value.push(...response.list)
            } else {
                // 首次加载：替换数据
                characterList.value = response.list
                // 如果用户已登录，标记为个性化数据
                if (userStore.isLoggedIn) {
                    isPersonalizedData.value = true
                }
            }

            // 更新offset和pageCursor
            offset.value = response.offset
            pageCursor.value = response.page_cursor

            // 检查是否还有更多数据
            finished.value = !response.hasMore
            // 只有在 LATEST 下才记录分页状态（HISTORY 不走这里）
            if (activeTab.value === 'LATEST') {
                finishedLatest.value = finished.value
            }
        } else {
            error.value = true
        }
    } catch (err) {
        console.error('加载角色列表失败:', err)
        error.value = true
    } finally {
        loading.value = false
        // 确保loading被关闭
        isUpdatingData.value = false
    }
}

// 无限滚动禁用状态
const scrollDisabled = computed(
    () => loading.value || finished.value || error.value
)

// 无限滚动加载事件
const onLoad = () => {
    if (!loading.value && !finished.value && !error.value) {
        loadCharacterList(true)
    }
}

// 获取个性化数据（用户登录状态下）
const loadPersonalizedData = async () => {
    if (!userStore.isLoggedIn) {
        return
    }

    try {
        console.log('正在获取个性化数据...')

        // 确保loading至少显示600ms，让用户感知到个性化处理过程
        const [response] = await Promise.all([
            getCharacterList('0', pageSize, ''),
            new Promise(resolve => setTimeout(resolve, 600)),
        ])

        if (response) {
            // 先关闭loading，再更新数据
            isUpdatingData.value = false
            await nextTick()

            // 处理个性化数据为空的情况
            if (response.list.length === 0) {
                console.log('用户个性化数据为空，清空首页数据')
                characterList.value = []
                offset.value = response.offset
                pageCursor.value = response.page_cursor
                finished.value = !response.hasMore
                isPersonalizedData.value = true
                console.log('已清空首页数据')
                return
            }

            // 对比数据，如果有差异才更新（避免不必要的DOM更新）
            const currentIds = characterList.value.map(item => item.id).sort()
            const newIds = response.list.map(item => item.id).sort()
            const hasChanged =
                currentIds.length !== newIds.length ||
                currentIds.some((id, index) => id !== newIds[index])

            if (hasChanged) {
                console.log('检测到个性化数据差异，更新列表')
                characterList.value = response.list
            } else {
                console.log('个性化数据与SSR数据一致，无需更新列表')
            }

            // ⚠️ 关键修复：必须更新分页状态，即使列表数据一致！
            // 因为个性化API返回的分页参数可能与SSR不同
            offset.value = response.offset
            pageCursor.value = response.page_cursor
            finished.value = !response.hasMore

            isPersonalizedData.value = true
            console.log('个性化数据处理完成')
        }
    } catch (err) {
        console.error('获取个性化数据失败:', err)
        // 如果个性化数据获取失败，保持SSR数据
    } finally {
        // 确保loading被关闭
        isUpdatingData.value = false
    }
}

// 重置列表（切换分类时使用）
const resetList = () => {
    offset.value = '0'
    pageCursor.value = ''
    finished.value = false
    finishedLatest.value = false
    characterList.value = []
    // 重置个性化数据状态，并显示loading
    isPersonalizedData.value = false
    isUpdatingData.value = true // 切换标签或筛选时始终显示loading
    loadCharacterList(false)
}

// 重置筛选
const handleReset = () => {
    selectedLabels.value = ['ALL']
    selectedGenders.value = ['MALE', 'FEMALE']
    resetList()
}

// 等待 mateUser token 就绪
const waitForMateToken = async (): Promise<void> => {
    // 如果已经有 mateToken，直接返回
    if (userStore.mateToken) {
        console.log('mateToken已存在，无需等待')
        return
    }

    // 等待 mateToken（最多等待3秒）
    let waitCount = 0
    const maxWait = 30 // 30 * 100ms = 3秒

    while (waitCount < maxWait && !userStore.mateToken) {
        await new Promise(resolve => setTimeout(resolve, 100))
        waitCount++
    }

    if (!userStore.mateToken) {
        console.warn('等待mateToken超时，将继续执行（可能会遇到认证问题）')
    } else {
        console.log('mateToken已就绪，耗时:', waitCount * 100, 'ms')
    }
}

// 更新窗口高度
const updateWindowHeight = () => {
    if (import.meta.client) {
        windowHeight.value = window.innerHeight
    }
}

// mate 角色 end

watch(
    () => visible.value,
    newVal => {
        if (newVal) {
            userStore.getUserInfo(true)
            // 弹窗开启时，重新检测是否需要展开按钮
            checkNeedsExpandButton()
            // 弹窗开启时，初始化滚动监听
            initObserver()
        } else {
            // 弹窗关闭时，销毁监听器防止内存泄漏
            if (loadMoreObserver) {
                loadMoreObserver.disconnect()
                loadMoreObserver = null
            }
        }
    }
)

const isClient = ref(false)

onMounted(async () => {
    if (typeof window !== 'undefined') {
        try {
            const { dotSpinner } = await import('ldrs')
            dotSpinner.register()
            // 确保注册完成后再设置 isClient，避免组件在注册前渲染
            isClient.value = true
        } catch (error) {
            console.error('Failed to load ldrs:', error)
            // 即使加载失败也设置为 true，避免无限等待
            isClient.value = true
        }
    }

    if (import.meta.client) {
        // 初始化窗口高度
        updateWindowHeight()
        // 添加窗口 resize 监听
        window.addEventListener('resize', updateWindowHeight, { passive: true })

        // 检测标签是否需要展开按钮
        checkNeedsExpandButton()
        // 窗口大小变化时重新检测
        window.addEventListener('resize', checkNeedsExpandButton, {
            passive: true,
        })

        // 如果初始状态就是可见的，则初始化滚动监听
        if (visible.value) {
            initObserver()
        }
    }

    // 给一点时间让用户状态恢复完成
    setTimeout(async () => {
        if (userStore.isLoggedIn) {
            // 用户已登录，等待mateUser token就绪后再获取个性化数据
            console.log('检测到用户已登录，等待mateUser token就绪')
            await waitForMateToken()
            console.log('mateUser token已就绪，开始获取个性化数据')
            loadPersonalizedData()
            // 加载聊天列表
            loadChatList()
        } else {
            // 用户未登录，等待SSR数据加载完成后再移除loading
            console.log('用户未登录，等待SSR数据加载完成，当前状态:', {
                pending: initialDataPending.value,
                hasData: !!initialData.value,
                listLength: characterList.value.length,
            })

            // 等待SSR数据加载完成（最多等待5秒）
            let waitCount = 0
            const maxWait = 50 // 50 * 100ms = 5秒

            while (
                waitCount < maxWait &&
                (initialDataPending.value || characterList.value.length === 0)
            ) {
                await new Promise(resolve => setTimeout(resolve, 100))
                waitCount++
            }

            console.log('SSR数据加载完成或超时，移除loading，最终状态:', {
                pending: initialDataPending.value,
                hasData: !!initialData.value,
                listLength: characterList.value.length,
                waitedMs: waitCount * 100,
            })

            setTimeout(() => {
                isUpdatingData.value = false
            }, 100)
        }
    }, 150) // 稍微增加等待时间，确保用户状态完全恢复
})

// 监听用户登录状态变化
watch(
    () => userStore.isLoggedIn,
    async isLoggedIn => {
        if (isLoggedIn && !isPersonalizedData.value) {
            // 用户刚登录，显示loading并获取个性化数据
            isUpdatingData.value = true
            // 等待 mateToken 就绪
            await waitForMateToken()
            loadPersonalizedData()
            // 加载聊天列表
            loadChatList()
        } else if (!isLoggedIn && isPersonalizedData.value) {
            // 用户退出登录，重置为SSR数据
            resetToSSRData()
            // 清空聊天列表
            chatList.value = []
        }
    }
)

// 重置为SSR数据
const resetToSSRData = () => {
    if (initialData.value) {
        characterList.value = initialData.value.list
        offset.value = initialData.value.offset
        pageCursor.value = initialData.value.page_cursor
        finished.value = !initialData.value.hasMore
        finishedLatest.value = finished.value
        isPersonalizedData.value = false
        console.log('已重置为SSR数据')
    }
}
// const select_list = defineModel('character_select_list', {
//     type: Array<any>,
//     default: () => [],
// })

const select_list = ref<Array<any>>([])

/**
 * 统一“角色唯一标识”，避免不同列表字段不一致导致选中态无法正确对齐：
 * - 推荐列表：一般是 id
 * - 历史聊天列表：可能是 match_mate_id / mate_id（这里优先 match_mate_id）
 * - 兜底：avatar（极端情况下）
 */
const getCharacterKey = (c: any): string => {
    if (c?.id !== undefined && c?.id !== null) return String(c.id)
    if (c?.match_mate_id !== undefined && c?.match_mate_id !== null)
        return String(c.match_mate_id)
    if (c?.mate_id !== undefined && c?.mate_id !== null)
        return String(c.mate_id)
    if (typeof c?.avatar === 'string' && c.avatar) return c.avatar
    return ''
}

// 选中态用“key 集合”表示，避免给列表 item 写入 `selected` 导致深度监听递归触发
const selectedKeySet = computed(() => {
    return new Set(
        (select_list.value || []).map(getCharacterKey).filter(Boolean)
    )
})

const isSelected = (item: any) => {
    const key = getCharacterKey(item)
    return !!key && selectedKeySet.value.has(key)
}

// 存入 select_list 的对象使用浅拷贝，避免与列表源数据/props 共享同一引用
const normalizeSelectItem = (item: any) => {
    return item ? { ...item } : item
}

const currentListData: any = computed(() => {
    if (activeTab.value === 'LATEST') {
        console.log('characterList', characterList.value)
        return characterList.value
    } else {
        return chatList.value
    }
})

const emit = defineEmits(['change'])
// 选择角色
const handleSelectItem = (character: CharacterItem) => {
    console.log('character', character)
    const key = getCharacterKey(character)
    const alreadySelected = !!key && selectedKeySet.value.has(key)
    if (props.max_limit === 1) {
        // 单选：再次点击同一个则取消选择
        select_list.value = alreadySelected
            ? []
            : [normalizeSelectItem(character)]
        return
    }
    if (select_list.value.length >= props.max_limit && !alreadySelected) {
        return
    }
    if (!key) return
    if (!alreadySelected) {
        // 关键：使用“重新赋值”触发 v-model update，避免仅 push 导致上层不更新
        // 去重：避免同一角色多次写入（不同 tab/重复点击等）
        select_list.value = [
            ...select_list.value,
            normalizeSelectItem(character),
        ]
    } else {
        select_list.value = select_list.value.filter(
            item => getCharacterKey(item) !== key
        )
    }
}

// 移除角色
const handleRemoveItem = (item: CharacterItem) => {
    const key = getCharacterKey(item)
    select_list.value = select_list.value.filter(
        it => getCharacterKey(it) !== key
    )
}

const handleSubmitSelectList = () => {
    emit('change', select_list.value)
    handleClose()
}

const handleClose = () => {
    visible.value = false
    select_list.value = []
}

watch(
    [() => props.character_select_list, () => visible.value],
    ([newVal, newVisible]) => {
        if (newVal && newVisible) {
            // 用新数组 + 浅拷贝元素，避免引用同一份对象造成深度监听递归
            select_list.value = Array.isArray(newVal)
                ? newVal.map(v => normalizeSelectItem(v))
                : []
        }
    },
    {
        immediate: true,
    }
)

// 单独控制 body 滚动，避免混在同步逻辑里导致额外触发链条
watch(
    () => visible.value,
    v => {
        if (!import.meta.client || typeof document === 'undefined') return
        document.body.style.overflow = v ? 'hidden' : 'auto'
    },
    { immediate: true }
)

// 监听初始数据加载完成
watch(
    () => initialData.value,
    newData => {
        if (newData && characterList.value.length === 0) {
            console.log('SSR数据已加载，设置角色列表')
            characterList.value = newData.list
            offset.value = newData.offset
            pageCursor.value = newData.page_cursor
            finished.value = !newData.hasMore

            // 如果用户未登录且loading还在显示，可以移除loading了
            if (!userStore.isLoggedIn && isUpdatingData.value) {
                console.log('用户未登录且数据已就绪，移除loading')
                nextTick(() => {
                    isUpdatingData.value = false
                })
            }
        }
    },
    { immediate: true }
)

// 监听标签选项变化，重新检测是否需要展开按钮
watch(
    () => labelOptions.value,
    () => {
        checkNeedsExpandButton()
    },
    { deep: true }
)

// 组件卸载时清理方法锁和事件监听
onUnmounted(() => {
    methodLock.clear() // 清理所有方法锁
    if (import.meta.client) {
        // 兜底：组件卸载时恢复滚动（避免异常关闭导致 body 锁死）
        if (typeof document !== 'undefined') {
            document.body.style.overflow = 'auto'
        }
        window.removeEventListener('resize', updateWindowHeight)
        window.removeEventListener('resize', checkNeedsExpandButton)

        if (loadMoreObserver) {
            loadMoreObserver.disconnect()
            loadMoreObserver = null
        }
    }
    // 清理筛选防抖定时器
    if (filterDebounceTimer) {
        clearTimeout(filterDebounceTimer)
        filterDebounceTimer = null
    }
})
</script>

<style scoped lang="less">
.generate {
    &:hover:not(.disabled) {
        transform: translateY(-2px);
        box-shadow: 0 12px 40px rgba(153, 247, 104, 0.5);
    }
}

@media (max-width: 420px) {
    .avatar-editor {
        flex-direction: column;
    }
}

.is-active {
    &::after {
        content: '';
        position: absolute;
        bottom: -6px;
        left: 0;
        width: 100%;
        height: 3px;
        border-radius: 3px;
        background: #99f768;
    }
}

/* SEO H1 标签 - 视觉隐藏但可被搜索引擎读取 */
.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}

/* 主题色相关样式 */
.primary-border {
    border-color: @tag-selected-bg;
}

.primary-bg {
    background-color: @tag-selected-bg;
}

/* 隐藏滚动条 */
.scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.scrollbar-hide::-webkit-scrollbar {
    display: none;
}

/* 文本截断样式 */
.line-clamp-1 {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.line-clamp-3 {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

/* 悬浮层描述文字截断 - 10行 */
.line-clamp-description {
    display: -webkit-box;
    -webkit-line-clamp: 10;
    line-clamp: 10;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
}

/* 视频播放图标动画 */
.video-play-icon {
    animation: pulse 2s infinite;
}

@keyframes pulse {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0.7;
    }
}

/* 角色卡片图片区域 - 使用宽高比控制 */
.character-card-image {
    width: 100%;
    aspect-ratio: 167.5 / 210;
    /* 移动端：167.5:210 比例 */
    overflow: hidden;
}

/* PC端（中等屏幕及以上） */
@media (min-width: 768px) {
    .character-card-image {
        aspect-ratio: 248 / 320;
        /* PC端：258:320 比例 */
    }
}

/* 骨架屏光效动画 */
@keyframes shimmer {
    0% {
        transform: translateX(-100%);
    }

    100% {
        transform: translateX(100%);
    }
}

.animate-shimmer {
    animation: shimmer 2s infinite;
}

/* 自定义滚动条样式 */
.scrollbar-custom::-webkit-scrollbar {
    width: 6px;
}

.scrollbar-custom::-webkit-scrollbar-track {
    background: transparent;
}

.scrollbar-custom::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
}

.scrollbar-custom::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.2);
}

.name-item {
    background: rgba(167, 171, 178, 0.2);
    backdrop-filter: blur(15px);
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}

.normal-select {
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.4);
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(6px);
}

.select-active-icon {
    mask: url('~/assets/images/menu/select.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/select.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: var(--weryai-text-active);
}

/* 移动端底部安全区（iPhone home indicator 等），仅影响样式 */
.safe-bottom {
    padding-bottom: calc(env(safe-area-inset-bottom) + 12px);
}

.custom-pop::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 18px !important;
    padding: 1px;
    background: linear-gradient(180deg,
            rgba(255, 255, 255, 0.1) 0%,
            transparent 100%);
    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    z-index: 1;
}
</style>
